import { createSlice } from "@reduxjs/toolkit";

const staffSlice = createSlice({
  name: "staff",
  initialState: { list: [] },
  reducers: {
    setAllStaff: (state, action) => { state.list = action.payload; },
    removeStaff: (state, action) => {
      state.list = state.list.filter((s) => s.staffId !== action.payload);
    },
  },
});

export const { setAllStaff, removeStaff } = staffSlice.actions;
export default staffSlice.reducer;
